import {
  sendChatMessageAPI,
  getConversationsAPI,
  getConversationAPI,
  deleteConversationAPI,
  renameConversationAPI,
  submitFeedbackAPI,
} from "api/chat-api";
import {
  SEND_CHAT_MESSAGE_INIT,
  SEND_CHAT_MESSAGE_SUCCESS,
  SEND_CHAT_MESSAGE_FAILED,
  GET_CONVERSATIONS_INIT,
  GET_CONVERSATIONS_SUCCESS,
  GET_CONVERSATIONS_FAILED,
  GET_CONVERSATION_INIT,
  GET_CONVERSATION_SUCCESS,
  GET_CONVERSATION_FAILED,
  DELETE_CONVERSATION_INIT,
  DELETE_CONVERSATION_SUCCESS,
  DELETE_CONVERSATION_FAILED,
  RENAME_CONVERSATION_INIT,
  RENAME_CONVERSATION_SUCCESS,
  RENAME_CONVERSATION_FAILED,
  SET_ACTIVE_CONVERSATION,
  CLEAR_CHAT,
  ADD_USER_MESSAGE,
  SUBMIT_FEEDBACK_INIT,
  SUBMIT_FEEDBACK_SUCCESS,
  SUBMIT_FEEDBACK_FAILED,
} from "actions/types/chat-types";

export function sendChatMessage(question, conversationId, provider) {
  return (dispatch) => {
    dispatch({ type: SEND_CHAT_MESSAGE_INIT });
    dispatch({
      type: ADD_USER_MESSAGE,
      message: { role: "user", content: question },
    });
    sendChatMessageAPI(question, conversationId, provider || "agent-1")
      .then((response) => {
        dispatch({ type: SEND_CHAT_MESSAGE_SUCCESS, response });
        dispatch(getConversations());
      })
      .catch((error) => dispatch({ type: SEND_CHAT_MESSAGE_FAILED, error }));
  };
}

export function getConversations(limit, offset) {
  return (dispatch) => {
    dispatch({ type: GET_CONVERSATIONS_INIT });
    getConversationsAPI(limit, offset)
      .then((response) =>
        dispatch({ type: GET_CONVERSATIONS_SUCCESS, response })
      )
      .catch((error) => dispatch({ type: GET_CONVERSATIONS_FAILED, error }));
  };
}

export function getConversation(conversationId) {
  return (dispatch) => {
    dispatch({ type: GET_CONVERSATION_INIT });
    getConversationAPI(conversationId)
      .then((response) =>
        dispatch({ type: GET_CONVERSATION_SUCCESS, response })
      )
      .catch((error) => dispatch({ type: GET_CONVERSATION_FAILED, error }));
  };
}

export function deleteConversation(conversationId) {
  return (dispatch) => {
    dispatch({ type: DELETE_CONVERSATION_INIT });
    deleteConversationAPI(conversationId)
      .then((response) =>
        dispatch({
          type: DELETE_CONVERSATION_SUCCESS,
          response,
          conversationId,
        })
      )
      .catch((error) => dispatch({ type: DELETE_CONVERSATION_FAILED, error }));
  };
}

export function renameConversation(conversationId, title) {
  return (dispatch) => {
    dispatch({ type: RENAME_CONVERSATION_INIT });
    renameConversationAPI(conversationId, title)
      .then((response) =>
        dispatch({ type: RENAME_CONVERSATION_SUCCESS, response })
      )
      .catch((error) => dispatch({ type: RENAME_CONVERSATION_FAILED, error }));
  };
}

export function setActiveConversation(conversationId) {
  return { type: SET_ACTIVE_CONVERSATION, conversationId };
}

export function clearChat() {
  return { type: CLEAR_CHAT };
}

export function submitFeedback(messageId, payload) {
  return (dispatch) => {
    dispatch({ type: SUBMIT_FEEDBACK_INIT, messageId });
    submitFeedbackAPI(messageId, payload)
      .then((response) => {
        if (response && response.id) {
          dispatch({ type: SUBMIT_FEEDBACK_SUCCESS, messageId, response });
        } else {
          dispatch({ type: SUBMIT_FEEDBACK_FAILED, messageId, error: response });
        }
      })
      .catch((error) =>
        dispatch({ type: SUBMIT_FEEDBACK_FAILED, messageId, error })
      );
  };
}
